export enum HandPosition {
    DEALER = "DEALER",
    PLAYER_RIGHT = "PLAYER_RIGHT",
    PLAYER_CENTER = "PLAYER_CENTER",
    PLAYER_LEFT = "PLAYER_LEFT",
}



// WEBPACK FOOTER //
// ./src/app/HandPosition.ts